import { REFERRALS } from '../types';
import { ReferralTile } from '../components/ReferralTile';
import { useNewReferrals } from '../hooks/useNewReferrals';
import { useEffect } from 'react';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { ShoppingBagIcon } from '../../assets/icons';

export const Marketplace = () => {
  useAnalyticsPage(Page.MARKETPLACE);

  const { setViewedReferrals } = useNewReferrals();
  useEffect(() => {
    setViewedReferrals(REFERRALS.map((x) => x.code));
  }, [setViewedReferrals]);

  return (
    <div className="marketplace__container">
      <div>
        <ShoppingBagIcon className="align-text-bottom" />
        <span className="growegy-font-em growegy-font20--weight500">&nbsp;Marketplace</span>
      </div>
      <div className="growegy-title14--moderat">
        Discover a handpicked selection of services tailored for small businesses, featuring
        exclusive bonuses and discounts just for you!
      </div>
      <div className="marketplace__referrals-container">
        <>
          {REFERRALS.filter((x) => !x.hidden).map((x) => (
            <ReferralTile key={`referral-${x.code}`} referral={x} />
          ))}
        </>
      </div>
    </div>
  );
};
